import { FC } from 'react'
import styled from 'styled-components'
import { useIsGsat2025SecondRoute } from '@app.feature/exam/hooks/useIsGsat2025SecondRoute'

interface TestInfoLayoutDesktopProps {
  title: string
  subText?: string
  guideText?: string
  className?: string
  isDisplayedCorrectRate?: boolean
}

const TestInfoLayoutDesktop: FC<TestInfoLayoutDesktopProps> = ({
  title,
  children,
  subText,
  guideText,
  className,
  isDisplayedCorrectRate = false,
}) => {
  const isGsat2025SecondRoute = useIsGsat2025SecondRoute()

  return (
    <StyledWrapper className={className}>
      <strong>{title}</strong>
      {subText && <p className="sub-text">{subText}</p>}
      <span className="info-content">{children}</span>
      {guideText && <p className="guide-text">※ {guideText}</p>}

      {isGsat2025SecondRoute && isDisplayedCorrectRate && (
        <p className="guide-text">
          ※ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다.
        </p>
      )}
    </StyledWrapper>
  )
}

export default TestInfoLayoutDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > strong {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.88px;
    text-align: left;
    color: #333;
  }

  > .sub-text {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.47;
    letter-spacing: -0.6px;
    color: #333;
    margin-top: 8px;
  }

  > .info-content {
    margin-top: 24px;
  }

  > .guide-text {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.47;
    letter-spacing: -0.6px;
    color: #666666;
    margin-top: 16px;
  }
`
